import { render, staticRenderFns } from "./AgentsForm.vue?vue&type=template&id=7235a06d&"
import script from "./AgentsForm.vue?vue&type=script&lang=js&"
export * from "./AgentsForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentsForm.vue?vue&type=style&index=0&id=7235a06d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports